import { parseChatTimestamp } from "./chatMessages.mjs";

export const getOrganizationKey = (organization) =>
  organization ? `${organization.type}:${organization.id}` : null;

export const getExistingThreadId = (chat) => {
  if (!chat || chat.has_thread === false) return null;
  return chat.threadId || chat.thread_id || (chat.thread_type || chat.has_thread ? chat.id : null);
};

export const findLastThreadOrganization = (organizations, lastThread) => {
  if (!lastThread?.thread_id) return null;
  return (
    organizations.find((organization) => {
      if (organization.type === "provider") {
        return String(organization.id) === String(lastThread.partner_provider_id);
      }
      if (organization.type === "copilot") {
        return String(organization.id) === String(lastThread.partner_copilot_firm_id);
      }
      return (
        lastThread.resume_mode === "attorney_internal" &&
        String(organization.id) === String(lastThread.firm_id)
      );
    }) || null
  );
};

export const selectDefaultChat = (chats, preferredThreadIds = []) => {
  if (!chats.length) return null;
  const existingChats = chats.filter((chat) => getExistingThreadId(chat));
  if (!existingChats.length) return chats[0];
  const candidates = existingChats;

  for (const threadId of preferredThreadIds) {
    if (threadId === null || threadId === undefined) continue;
    const remembered = candidates.find(
      (chat) => String(getExistingThreadId(chat)) === String(threadId)
    );
    if (remembered) return remembered;
  }

  const createdAt = (chat) =>
    parseChatTimestamp(chat.thread_created_at || chat.created_at)?.getTime() ?? Infinity;

  return candidates.reduce((oldest, chat) => (createdAt(chat) < createdAt(oldest) ? chat : oldest));
};

const historyKey = (userId, firmId) => `chat-selection:${firmId}:${userId}`;

export const readChatSelection = (storage, userId, firmId) => {
  try {
    const saved = JSON.parse(storage.getItem(historyKey(userId, firmId)) || "null");
    return saved && typeof saved.byOrganization === "object" && saved.byOrganization !== null
      ? saved
      : { byOrganization: {} };
  } catch {
    return { byOrganization: {} };
  }
};

export const rememberChatSelection = (storage, userId, firmId, organization, threadId) => {
  if (!userId || !organization || !threadId) return;
  const saved = readChatSelection(storage, userId, firmId);
  const organizationKey = getOrganizationKey(organization);
  saved.lastOrganization = organizationKey;
  saved.byOrganization[organizationKey] = { threadId, openedAt: Date.now() };
  try {
    storage.setItem(historyKey(userId, firmId), JSON.stringify(saved));
  } catch {
    // Opening a conversation must still work when browser storage is unavailable.
  }
};
